import Vue from "vue";
import VueRouter from "vue-router";
import i18n from "@/locales/index";
const originalPush = VueRouter.prototype.push;

VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => {
    // Only ignore NavigationDuplicated errors
    if (err.name !== "NavigationDuplicated") {
      console.error("Navigation error:", err);
      throw err; // Re-throw other errors
    }
    return Promise.resolve(false);
  });
}; //解决路由重复点击报错问题

Vue.use(VueRouter);

export const routes = [
  {
    path: "/login",
    name: "login",
    component: () =>
      import(/* webpackChunkName: "noauthneed-login" */ "@/views/login/index"),
    hidden: true,
    meta: { hideNotificationBar: true },
  },
  {
    path: "/auth/magic-login",
    name: "magic-login",
    component: () =>
      import(
        /* webpackChunkName: "noauthneed-magic-login" */ "@/views/auth/MagicLoginRedeem.vue"
      ),
    hidden: true,
    meta: { hideNotificationBar: true },
  },
  {
    path: "/signup",
    name: "Signup",
    component: () =>
      import(/* webpackChunkName: "noauthneed-signup" */ "@/views/signup"),
  },
  {
    path: "/forgot",
    name: "Forgot",
    component: () =>
      import(/* webpackChunkName: "noauthneed-forgot" */ "@/views/forgot"),
  },
  {
    path: "/credentials/authenticate/success",
    name: "authenticate success",
    component: () =>
      import(
        /* webpackChunkName: "noauthneed-auth-success" */ "@/views/credential/authenticate/authenticate-suceess.vue"
      ),
  },
  {
    path: "/credentials/authenticate/failure",
    name: "authenticate failure",
    component: () =>
      import(
        /* webpackChunkName: "noauthneed-auth-failed" */ "@/views/credential/authenticate/authenticate-failure.vue"
      ),
  },
  {
    path: "/",
    component: () =>
      import(/* webpackChunkName: "dashboard" */ "@/views/dashboard/index.vue"),
    redirect: { name: "home" },
    children: [
      {
        path: "onboarding",
        name: "onboarding",
        component: () =>
          import(
            /* webpackChunkName: "onboarding-page" */ "@/views/onboarding"
          ),
        meta: { title: "onboarding_hub" },
      },
      {
        path: "home",
        name: "home",
        component: () =>
          import(/* webpackChunkName: "dashboard-home" */ "@/views/home"),
        meta: { title: "navHome", keepAlive: true, hasTopSearch: true },
      },
      {
        path: "people",
        name: "people",
        redirect: { name: "people-search" },
        component: () =>
          import(
            /* webpackChunkName: "people-search" */ "@/views/search/people"
          ),
        meta: { title: "navProspect" },
        children: [
          {
            path: "search",
            name: "people-search",
            // component: () =>
            //   import(/* webpackChunkName: "people" */ "@/views/search/people"),
            // meta: { title: "navProspect", module: "people" },

            component: {
              render(h) {
                return h("router-view");
              },
            },
            meta: { title: "navProspect", module: "people" },
          },
        ],
      },
      {
        path: "company",
        name: "company",
        component: () =>
          import(
            /* webpackChunkName: "company" */ "@/views/search/companies/index"
          ),
        redirect: { name: "company-search" },
        meta: { title: "navCompanies" },
        children: [
          {
            path: "search",
            name: "company-search",
            component: () =>
              import(
                /* webpackChunkName: "company-search" */ "@/views/search/companies/company-list.vue"
              ),
            meta: { title: "navCompanies", module: "company" },
          },
          {
            path: "detail/:domain_search_id",
            name: "company-detail",
            component: () =>
              import(
                /* webpackChunkName: "company-detail" */ "@/views/search/companies/company-detail"
              ),
            meta: { title: "companyDetail", module: "company" },
          },
        ],
      },
      {
        path: "enrich",
        name: "enrich",
        component: () =>
          import(/* webpackChunkName: "enrich" */ "@/views/enrich"),
        redirect: { name: "enrich-new" },
        meta: { title: "navEnrich" },
        children: [
          {
            path: "new",
            name: "enrich-new",
            component: () =>
              import(/* webpackChunkName: "enrich-new" */ "@/views/enrich/new"),
            meta: { title: "navEnrich", module: "enrich" },
          },
          {
            path: "history",
            name: "enrich-history",
            component: () =>
              import(
                /* webpackChunkName: "enrich-history" */ "@/views/enrich/history"
              ),
            meta: { title: "navEnrich", module: "enrich" },
          },
          // Backwards-compatible redirects so old bookmarks don't 404.
          { path: "people", redirect: { name: "enrich-new" } },
          { path: "companies", redirect: { name: "enrich-new" } },
          { path: "jobs", redirect: { name: "enrich-history" } },
        ],
      },
      {
        // `:channel` (email/linkedin/...) + `:id` (provider thread external_id) as first-class params.
        path: "inboxes/:channel?/:id?",
        name: "inbox",
        component: () =>
          import(/* webpackChunkName: "inbox" */ "@/views/inboxes/inbox.vue"),
        meta: { title: "navInbox", module: "inbox" },
      },
      // Legacy /inbox redirects keep old bookmarks / Slack links resolvable.
      {
        path: "inbox",
        redirect: { name: "inbox" },
      },
      {
        path: "inbox/:id",
        redirect: (to) => {
          const raw = String(to.params.id || "");
          const [channel, ...rest] = raw.split(/[|~]/);
          const id = rest.join("|");
          return {
            name: "inbox",
            params: channel && id ? { channel, id } : {},
          };
        },
      },
      {
        path: "sequence",
        name: "sequence",
        component: () =>
          import(/* webpackChunkName: "sequence" */ "@/views/sequence/index"),
        meta: { title: "Sequences" },
        redirect: { name: "sequence-list" },
        children: [
          {
            path: "sequence-list",
            name: "sequence-list",
            component: () =>
              import(
                /* webpackChunkName: "sequence-list" */ "@/views/sequence/sequence-list"
              ),
            meta: { title: "navSequence", module: "sequence" },
          },
          {
            path: "sequence-templates",
            name: "sequence-templates",
            component: () =>
              import(
                /* webpackChunkName: "sequence-templates" */ "@/views/sequence/templates/sequence-templates.vue"
              ),
            meta: { title: "Templates", module: "sequence" },
          },
          {
            path: "sequence-credentials",
            name: "sequence-credentials",
            component: () =>
              import(
                /* webpackChunkName: "sequence-credential" */
                "@/views/sequence/sequence-credentials/sequence-credentials.vue"
              ),
            meta: { title: "sequence_tab_credentials", module: "sequence" },
          },
          {
            path: "sequence-settings",
            name: "sequence-settings",
            component: () =>
              import(
                /* webpackChunkName: "sequence-settings" */
                "@/views/sequence/sequence-schedule/sequence-schedule.vue"
              ),
            meta: { title: "Settings", module: "sequence" },
          },
        ],
      },
      {
        path: "sequence-detail/:id",
        name: "sequence-detail",
        meta: { title: "navSequenceDetail" },
        redirect: { name: "sequence_detail_nav_steps" },
        component: () =>
          import(
            /* webpackChunkName: "sequece-detail" */ "@/views/sequence/sequence-list/sequence-detail"
          ),

        children: [
          {
            path: "sequence_detail_nav_steps",
            name: "sequence_detail_nav_steps",
            component: () =>
              import(
                /* webpackChunkName: "sequence-detail-steps" */
                "@/views/sequence/sequence-list/sequence-detail/workflow/index.vue"
              ),
            meta: {
              title: "navSequenceDetail",
            },
          },
          {
            path: "sequence_detail_nav_report",
            name: "sequence_detail_nav_report",
            component: () =>
              import(
                /* webpackChunkName: "sequence-detail-report" */
                "@/views/sequence/sequence-list/sequence-detail/report/detail-report.vue"
              ),
            meta: {
              title: "navSequenceDetail",
            },
          },
          {
            path: "sequence_detail_nav_prospects",
            name: "sequence_detail_nav_prospects",
            component: () =>
              import(
                /* webpackChunkName: "sequence-detail-targets" */
                "@/views/sequence/sequence-list/sequence-detail/prospect/sequence-prospect.vue"
              ),
            meta: {
              title: "navSequenceDetail",
            },
          },
          {
            path: "sequence_detail_nav_logs",
            name: "sequence_detail_nav_logs",
            component: () =>
              import(
                /* webpackChunkName: "sequence-detail-logs" */
                "@/views/sequence/sequence-list/sequence-detail/detail-logs/detail-logs.vue"
              ),
            meta: {
              title: "navSequenceDetail",
            },
          },
          {
            path: "sequence_detail_nav_settings",
            name: "sequence_detail_nav_settings",
            component: () =>
              import(
                /* webpackChunkName: "sequence-detail-settings" */
                "@/views/sequence/sequence-list/sequence-detail/settings/detail-settings.vue"
              ),
            meta: {
              title: "navSequenceDetail",
            },
          },
        ],
      },
      {
        path: "services",
        name: "services",
        component: () =>
          import(
            /* webpackChunkName: "services" */ "@/views/services/overview"
          ),
        meta: { title: "navService" },
      },
      {
        path: "sheets",
        name: "sheets",
        component: () =>
          import(/* webpackChunkName: "sheets" */ "@/views/sheets/main.vue"),
        meta: { title: "sheets" },
      },
      {
        path: "monitors",
        name: "monitors",
        component: () =>
          import(/* webpackChunkName: "monitors" */ "@/views/monitors"),
        redirect: { name: "monitors-list" },
        meta: { title: "monitors" },
        children: [
          {
            path: "list",
            name: "monitors-list",
            component: () =>
              import(
                /* webpackChunkName: "monitors-list" */
                "@/views/monitors/monitors-list/index.vue"
              ),
            meta: {
              title: "monitors",
            },
            children: [
              {
                path: "detail/:id",
                name: "monitors-detail",
                component: () =>
                  import(
                    /* webpackChunkName: "monitors-detail" */
                    "@/views/monitors/monitors-list/detail/index.vue"
                  ),
                meta: {
                  title: "monitors",
                },
                redirect: { name: "monitors-detail-flow" },

                children: [
                  {
                    path: "flow",
                    name: "monitors-detail-flow",
                    component: () =>
                      import(
                        /* webpackChunkName: "monitors-detail-flow" */
                        "@/views/monitors/monitors-list/detail/flow/index.vue"
                      ),
                    meta: {
                      title: "monitors",
                    },
                  },
                  {
                    path: "settings",
                    name: "monitors-detail-settings",
                    component: () =>
                      import(
                        /* webpackChunkName: "monitors-detail-flow" */
                        "@/views/monitors/monitors-list/detail/settings/index.vue"
                      ),
                    meta: {
                      title: "monitors",
                    },
                  },
                  {
                    path: "logs",
                    name: "monitors-detail-logs",
                    component: () =>
                      import(
                        /* webpackChunkName: "monitors-detail-flow" */
                        "@/views/monitors/monitors-list/detail/detail-logs/logs-table/index.vue"
                      ),
                    meta: {
                      title: "monitors",
                    },
                  },
                ],
              },
            ],
          },
          {
            path: "create",
            name: "monitors-create",
            component: () =>
              import(
                /* webpackChunkName: "monitors-create" */
                "@/views/monitors/monitors-create/index.vue"
              ),
            meta: {
              title: "create_monitor",
            },
          },
          {
            path: "edit/:id",
            name: "monitors-edit",
            component: () =>
              import(
                /* webpackChunkName: "monitors-edit" */
                "@/views/monitors/monitors-create/index.vue"
              ),
            meta: {
              title: "monitors_edit_title",
            },
          },
        ],
      },
      /*------setting相关路由-------*/
      {
        path: "settings",
        name: "settings",
        component: () =>
          import(/* webpackChunkName: "settings" */ "@/views/setting/index"),
        redirect: { name: "profile-organization" },
        meta: { title: "Setting", requiresAuth: true, module: "settings" },
        children: [
          {
            path: "profile-organization",
            name: "profile-organization",
            component: () =>
              import(
                /* webpackChunkName: "settings-profile" */
                "@/views/setting/profile-organization/profile-organization.vue"
              ),
            meta: { index: "1", title: "navSetting" },
          },
          {
            path: "plan-usage",
            name: "plan-usage",
            component: () =>
              import(
                /* webpackChunkName: "settings-plan-usage" */ "@/views/setting/plan-usage/plan-usage.vue"
              ),
            meta: { index: "1", title: "navSetting" },
          },
          {
            path: "upgrade-plan",
            name: "upgrade",
            component: () =>
              import(
                /* webpackChunkName: "settings-upgrade" */ "@/views/setting/pricing-plan/pricing-plan.vue"
              ),
            meta: { index: "1", title: "navSetting" },
          },
          {
            path: "billing",
            name: "billing",
            component: () =>
              import(
                /* webpackChunkName: "settings-billing" */ "@/views/setting/billing/billing"
              ),
            meta: { index: "1", title: "navSetting" },
          },
          {
            path: "customFields",
            name: "customField",
            component: () =>
              import(
                /* webpackChunkName: "settings-custom-field" */ "@/views/setting/custom-field/custom-field.vue"
              ),
            meta: { index: "3", title: "navSetting" },
          },
          {
            path: "roles",
            name: "permission",
            component: () =>
              import(
                /* webpackChunkName: "settings-permission" */ "@/views/setting/role/index.vue"
              ),
            children: [
              {
                path: "role-detail/:id",
                name: "role-detail",
                component: () =>
                  import(
                    /* webpackChunkName: "settings-permission-detail" */ "@/views/setting/role/detail/role-detail.vue"
                  ),
                meta: { title: "navSetting" },
              },
            ],
            meta: { title: "navSetting" },
          },
          {
            path: "teams",
            name: "team",
            component: () =>
              import(
                /* webpackChunkName: "settings-teams" */ "@/views/setting/team/index.vue"
              ),
            children: [
              {
                path: "team-detail/:id",
                name: "team-detail",
                component: () =>
                  import(
                    /* webpackChunkName: "settings-teams-detail" */ "@/views/setting/team/detail/team-detail.vue"
                  ),
                meta: { title: "navSetting" },
              },
            ],
            meta: { title: "navSetting" },
          },
          {
            path: "extensions",
            name: "extension",
            component: () =>
              import(
                /* webpackChunkName: "settings-extension" */ "@/views/setting/extension.vue"
              ),
            meta: { title: "navSetting" },
          },
          {
            path: "notifications",
            name: "notification",
            component: () =>
              import(
                /* webpackChunkName: "settings-notification" */ "@/views/setting/notification/index.vue"
              ),
            meta: { title: "navSetting" },
          },
          {
            path: "apiKeys",
            name: "apiKeys",
            component: () =>
              import(
                /* webpackChunkName: "settings-apikeys" */ "@/views/setting/ApiKeys/index.vue"
              ),
            meta: { title: "navSetting" },
          },
          {
            path: "users",
            name: "users",
            component: () =>
              import(
                /* webpackChunkName: "settings-users" */ "@/views/setting/users/users.vue"
              ),
            meta: { title: "navSetting" },
          },
          {
            path: "redeem_code",
            name: "redeem_code",
            component: () =>
              import(
                /* webpackChunkName: "settings-redeem-code" */ "@/views/setting/redeem-code/redeem-code.vue"
              ),
            meta: { title: "navSetting" },
          },
          {
            path: "referral_rewards",
            name: "referral_rewards",
            component: () =>
              import(
                /* webpackChunkName: "settings-referral" */ "@/views/setting/referral/setting-refferal.vue"
              ),
            meta: { title: "navSetting" },
          },
        ],
      },
    ],
  },

  {
    path: "/reset",
    name: "Reset",
    component: () =>
      import(/* webpackChunkName: "noauthneed-reset" */ "@/views/reset/reset"),
  },

  /*----------404--------------*/
  {
    path: "/:pathMatch(.*)",
    name: "not-found",
    component: () =>
      import(/* webpackChunkName: "noauthneed-notfound" */ "@/views/404"),
    meta: { hideNotificationBar: true },
  },
];

const router = new VueRouter({
  routes,
});

import Cookies from "js-cookie";
// Add navigation guard
router.beforeEach((to, from, next) => {
  document.title = to.meta?.title
    ? `Pubrio - ${i18n.t(to.meta.title)}`
    : "Pubrio";
  // Public routes that don't require authentication
  const publicRoutes = [
    "/login",
    "/signup",
    "/forgot",
    "/reset",
    "/auth/magic-login",
    "/credentials/authenticate/success",
    "/credentials/authenticate/failure",
  ];

  // Check if route requires authentication
  const requiresAuth =
    !publicRoutes.includes(to.path) && !to.path.startsWith("/reset");

  // Get authentication state from your store
  const isAuthenticated = Cookies.get("pubrio-token") || false;

  if (requiresAuth && !isAuthenticated) {
    next(`/login?returnUrl=${encodeURIComponent(to.fullPath)}`);
  } else {
    next();
  }
});

export default router;
